import React from "react";
import TipTapEditor from "../components/Common/TipTapEditor";
import Page from "../components/Common/Page";

const Texteditor = () => {
  const [value, setValue] = React.useState(
    `<p>According to Indeed.com in August 2022, the average annual salary for Technical Support is $51,758, though it can go considerably higher. The need for technology is constantly growing, as is the job market for tech support professionals.</p><p>In this course you’ll get an insider’s view into IT Support work. Learn about IT Support roles and levels, the support escalation matrix, ticketing systems, common support tools, and remote support software. </p><p>To help you with moving into the field, the course covers tech support career opportunities and career pathways from experienced, expert Information Technology professionals. </p><p>By the end of this course, you will be able to:</p><p>- Describe and develop a customer service and support mindset.</p><p>- Explore the features and benefits of ticketing systems.</p><p>- Identify support tools and systems used in technical support.</p><p>- Define the levels of IT support and the escalation matrix. </p><p>- Explore various tech support roles and responsibilities, including service-level agreement responsibilities.</p><p>- Recognize the career paths and progression in Technical Support.</p><p>This course provides several real-world inspired activities to demonstrate your skills in the areas of support tools, resolving IT issues, escalations and ticketing.</p><p>These skills will help you engage prospective employers and ask insightful questions that demonstrate your knowledge of the day-to-day role-related responsibilities.</p>`
  );

  return (
    <Page title="TipTap Text Editor">
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header mb-3">
            <div className="content-page-header">
              <h3 className="mb-1" style={{ fontWeight: 700, color: "#0f172a" }}>
                TipTap Rich Text Editor
              </h3>
              <p style={{ color: "#64748b", margin: 0, fontSize: 13 }}>
                Live validation surface for TipTap v3 with modern AntD-styled toolbar and clean HTML output.
              </p>
            </div>
          </div>
          {/* /Page Header */}

          <div className="row">
            <div className="col-md-12">
              <div className="card shadow-sm" style={{ borderRadius: 8, border: "1px solid #e2e8f0" }}>
                <div className="card-header bg-white" style={{ borderBottom: "1px solid #f1f5f9", padding: "14px 20px" }}>
                  <h5 className="card-title mb-0" style={{ fontSize: 15, fontWeight: 600, color: "#1e293b" }}>
                    Interactive Editor
                  </h5>
                </div>
                <div className="card-body" style={{ padding: "20px" }}>
                  <TipTapEditor
                    description={value}
                    onChange={(html) => setValue(html)}
                    height="380px"
                  />

                  {/* Live HTML Inspector */}
                  <div className="mt-4 pt-3" style={{ borderTop: "1px solid #f1f5f9" }}>
                    <h6 style={{ fontSize: 13, fontWeight: 600, color: "#475569", marginBottom: 8 }}>
                      Raw HTML Output:
                    </h6>
                    <pre
                      style={{
                        background: "#0f172a",
                        color: "#38bdf8",
                        padding: "12px 16px",
                        borderRadius: "6px",
                        fontSize: "12px",
                        maxHeight: "180px",
                        overflowY: "auto",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        fontFamily: "monospace"
                      }}
                    >
                      {value || "<em>(Empty)</em>"}
                    </pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Texteditor;
